import { storageRegionDictionary } from 'src/shared/entities/storage-regions';
import {
  gracePeriodOptionsDictionary,
  disruptedNotificationsOptionsDictionary,
} from 'src/shared/entities/escrow-notification-options';
import { getEscrowActivityNotificationOptions } from 'src/shared/entities/escrow-activity-notification-options';
import { assetVersionsLimitOptionsDictionary } from 'src/shared/entities/asset-versions-limit-options';

const { activityNotificationOptionsDictionary } = getEscrowActivityNotificationOptions('software');

export type ITechnicalField =
  | 'beneficiarySharedInformation'
  | 'beneficiaryActivityNotification'
  | 'beneficiaryDisruptionNotification'
  | 'beneficiaryDisruptionNotificationGracePeriod'
  | 'depositorActivityNotification'
  | 'depositorDisruptionNotification'
  | 'depositorDisruptionNotificationGracePeriod'
  | 'storageRegion'
  | 'assetVersionsLimit'
  | 'activationNotification';

export const getTechnicalSuggestedChangesItems = <K extends ITechnicalField, V extends string | boolean | number>(
  key: K,
  value: V,
) => {
  const keyToMessage = {
    beneficiarySharedInformation: {
      label: 'Asset visibility updated',
      value: typeof value === 'boolean' && value ? 'Show assets' : "Don't show assets",
    },
    beneficiaryActivityNotification: {
      label: 'Activity notification updated',
      value: activityNotificationOptionsDictionary[value as keyof typeof activityNotificationOptionsDictionary],
    },
    beneficiaryDisruptionNotification: {
      label: 'Disruption notification updated',
      value: disruptedNotificationsOptionsDictionary[value as keyof typeof disruptedNotificationsOptionsDictionary],
    },
    beneficiaryDisruptionNotificationGracePeriod: {
      label: 'Disruption notification grace period updated',
      value: gracePeriodOptionsDictionary[value as keyof typeof gracePeriodOptionsDictionary]?.label ?? '-',
    },
    depositorActivityNotification: {
      label: 'Activity notification updated',
      value: activityNotificationOptionsDictionary[value as keyof typeof activityNotificationOptionsDictionary],
    },
    depositorDisruptionNotification: {
      label: 'Disruption notification updated',
      value: disruptedNotificationsOptionsDictionary[value as keyof typeof disruptedNotificationsOptionsDictionary],
    },
    depositorDisruptionNotificationGracePeriod: {
      label: 'Disruption notification grace period updated',
      value: gracePeriodOptionsDictionary[value as keyof typeof gracePeriodOptionsDictionary]?.label ?? '-',
    },
    storageRegion: {
      label: 'Storage region updated',
      value: storageRegionDictionary[String(value)],
      ...(value !== 'default' && { badge: { label: 'Add-on', variant: 'default' } }),
    },
    assetVersionsLimit: {
      label: 'Asset version history limit updated',
      value:
        assetVersionsLimitOptionsDictionary[
          (value ? String(value) : 'full') as keyof typeof assetVersionsLimitOptionsDictionary
        ],
      ...(!value && { badge: { label: 'Add-on', variant: 'default' } }),
    },
    activationNotification: {
      label: 'Activation notification updated',
      value: value ? 'Send' : 'Don’t send',
    },
  };

  return key in keyToMessage ? (keyToMessage[key] as { label: string; value: string }) : { label: '', value: '' };
};
